import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "error-container" }
const _hoisted_2 = {
  key: 0,
  class: "error-toast"
}
const _hoisted_3 = { class: "error-message" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorDisplay',
  props: {
    message: {}
  },
  emits: ['close'],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "error-fade" }, {
      default: _withCtx(() => [
        (_ctx.message)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "error-icon" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" })
                ])
              ], -1)),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.message), 1),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                class: "close-btn",
                title: "Закрыть"
              }, " × ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})